import { IDPConnection } from '../components/types';

export enum SettingsEventsKeys {
  ForceView = 'forceView',
  RefreshConnections = 'refreshConnections',
  FormRefreshTrigger = 'formRefreshTrigger',
}

export enum ForcedState {
  INPUT_FIELDS_HOVER = 'INPUT_FIELDS_HOVER',
  INPUT_FIELDS_ERROR = 'INPUT_FIELDS_ERROR',
  GLOBAL_ERROR = 'GLOBAL_ERROR',
  SUBMIT_BUTTON_HOVER = 'SUBMIT_BUTTON_HOVER',
  FORGOT_PASSWORD_HOVER = 'FORGOT_PASSWORD_HOVER',
  SSO_BUTTON_HOVER = 'SSO_BUTTON_HOVER',
  PROFILE_POLICY_FOOTNOTE = 'PROFILE_POLICY_FOOTNOTE',
  REGULAR = 'REGULAR',
}

export interface SettingsEvents {
  [SettingsEventsKeys.ForceView]: ForcedState;
  [SettingsEventsKeys.RefreshConnections]: IDPConnection[]; // Pass the updated enabledConnections directly
  [SettingsEventsKeys.FormRefreshTrigger]: void;
}
